// extracted by mini-css-extract-plugin
module.exports = {"base":"Doc_base__3uKIj"};